import { combineReducers } from 'redux';
import BusFilterSlice from './busfilter/BusFilterSlice';
import LoadingModalSlice from './loadingModal/LoadingModalSlice';

const rootReducers = {
  busFilter: BusFilterSlice,
  loadingModal: LoadingModalSlice,
};

const appReducer = combineReducers(rootReducers);

const rootReducer = (state: any, action: any) => {
  /**
   * https://alligator.io/redux/reset-state-redux/
   * ------------------------------------------------
   */
  // if (action.type === APP_RESET_STORE) {
  //     const { application } = state;
  //     state = rootReducers;
  //     console.log(':::REDUX STORE RESET TO INITIAL', rootReducers);
  // }

  return appReducer(state, action);
};

// export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export default rootReducer;
